import { render } from "./SubPointBuy.vue?vue&type=template&id=013a8ce2&scoped=true"
import script from "./SubPointBuy.vue?vue&type=script&lang=js"
export * from "./SubPointBuy.vue?vue&type=script&lang=js"

import "./SubPointBuy.vue?vue&type=style&index=0&id=013a8ce2&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013a8ce2"]])

export default __exports__